





























































































































import { Component, Vue } from "vue-property-decorator";

import VCheckbox from "@/components/VCheckbox.vue";
import VSelect from "@/components/VSelect.vue";

import VNumericInput, {
  VNumericInputApplication,
} from "@/components/VNumericInput.vue";
import VCurrencyInput from "@/components/VCurrencyInput.vue";
import VPercentInput from "@/components/VPercentInput.vue";

import VSearchInput from "@/components/VSearchInput.vue";

@Component({
  components: {
    VCheckbox,
    VSelect,
    VNumericInput,
    VCurrencyInput,
    VPercentInput,
    VSearchInput,
  },
})
export default class FormControls extends Vue {
  protected multiSwitcherItems = [
    { id: "first", text: "Primo" },
    { id: "second", text: "Secondo" },
    { id: "third", text: "Terzo" },
  ];
  protected multiSwitcherIconItems = [
    { id: "bar", text: "bar-chart" },
    { id: "line", text: "line-chart" },
    { id: "pie", text: "pie-chart" },
  ];
  protected multiSwitcherValue = "first";
  protected multiSwitcherIconValue = "bar";
  protected check = false;

  protected vNumericValue = 0;
  protected vPercentValue = 0;
  protected vCurrencyValue = 0;

  get currency() {
    return VNumericInputApplication.CURRENCY;
  }
  get base() {
    return VNumericInputApplication.BASE;
  }
  get percent() {
    return VNumericInputApplication.PERCENT;
  }
}
